import React from "react";

export const AlertConfirmation = ({ message, onConfirm, onCancel }) => (
  <div className="alert-overlay">
    <div className="alert-box">
      <p dangerouslySetInnerHTML={{ __html: message }} />
      <div className="alert-buttons">
        <button className="custom-next-button" onClick={onCancel}>No</button>
        <button className="custom-close-button" onClick={onConfirm}>Yes</button>
      </div>
    </div>
  </div>
);

export const AlertSuccess = ({ message, onClose }) => (
  <div className="alert-overlay">
    <div className="alert-box success">
      <p>{message || "Action successful!"}</p>
      <div className="alert-buttons">
        <button className="btn-confirm" onClick={onClose}>OK</button>
      </div>
    </div>
  </div>
);

export const AlertError = ({ message, onClose }) => (
  <div className="alert-overlay">
    <div className="alert-box error">
      <p>{message || "Something went wrong!"}</p>
      <div className="alert-buttons">
        <button className="custom-close-button" onClick={onClose}>Close</button>
      </div>
    </div>
  </div>
);
